import MainLayout from "layout/MainLayout";
import Content from "views/content";
import PrivateRoute from "./PrivateRoute";
import Backups from "views/backups";
import Setting from "views/setting";
import Logs from "views/logs";

const MainRoutes = {
  path: "/",
  element: (
    <PrivateRoute>
      <MainLayout />
    </PrivateRoute>
  ),
  children: [
    {
      path: "/assets/:categoryId/:subCategoryId",
      element: (
        <PrivateRoute>
          <Content />
        </PrivateRoute>
      ),
    },
    {
      path: "/assets/:categoryId",
      element: (
        <PrivateRoute>
          <Content />
        </PrivateRoute>
      ),
    },
    {
      path: "/backups",
      element: (
        <PrivateRoute>
          <Backups />
        </PrivateRoute>
      ),
    },
    {
      path: "/setting",
      element: (
        <PrivateRoute>
          <Setting />
        </PrivateRoute>
      ),
    },
    {
      path: "/logs",
      element: (
        <PrivateRoute>
          <Logs />
        </PrivateRoute>
      ),
    },
  ],
};

export default MainRoutes;
